import axios from "axios";

const resendConfirmationEmail = async (email: string): Promise<boolean> => {
    try {
        const apiUrl = import.meta.env.VITE_API_URL;
        const response = await axios.post(
            `${apiUrl}/resendConfirmationEmail`,
            { email },
            { withCredentials: true }
        );

        if (response.status === 200) {
            // console.log("Confirmation email resent successfully");
            return true;
        }

        return false;
    } catch (error: any) {
        // console.error("Failed to resend confirmation email:", error?.response?.data || error.message);
        return false;
    }
};

export default resendConfirmationEmail;